<template>
    <el-row>
        <el-col>
            <div class="tips-text flex-column f-center">
                <span>No matter when you start, it is important not to stop after the start.</span>
                <span>Copyright @ 2024 湖南简易读科技有限公司</span>
            </div>
        </el-col>
    </el-row>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.tips-text {
    height: 143px;
    background: #B6E4D3;

    span {
        &:first-child {
            font-family: 思源黑体;
            font-size: 16px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 绿 */
            color: #0AA26B;
            @media screen and (max-width: 768px) {
                padding: 0 15px;
               text-align: center;
            }
        }

        &:last-child {
            margin-top: 11px;
            font-family: 思源黑体;
            font-size: 16px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }
    }
}
</style>